import React, { useEffect, useRef } from 'react';
import radium from 'radium';
import { ThemeContext } from "../../../components/theme/Theme.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


function CategoryListItem(props) {
	const context = React.useContext(ThemeContext);
	// Styles
	const style = {
		container: {
			alignItems: 'center',
			display: 'flex',
			padding: '0.5em 1em',
			height: '3em',
			cursor: 'pointer',
			width: '100%',
			outlineColor: context.themeManager.value('category-dropdown',
				'color', 'dropdown-separator-color'),
			':focus-visible': {
				outlineWidth: '7px',
				outlineStyle: 'solid'
			}
		},
		containerBorder: {
			borderBottom: '1px dotted',
			borderColor: context.themeManager.value('category-dropdown',
				'color', 'dropdown-separator-color'),
		},
		description: {
			alignItems: 'center',
			display: 'flex',
			width: '70%',
		},
		price: {
			display: 'flex',
			width: '20%',
		},
		categoryColor: {
			backgroundColor: props.categoryColor,
			flexShrink: 0,
			height: '1em',
			width: '1.4em',
		},
		label: {
			color: context.themeManager.value('category-dropdown',
				'color', 'fg-color-dropdown-text'),
			marginLeft: '1em',
		},
		checkIcon: {
			color: '#00FF00',
			fontSize: '2em',
		},
	};
	const firstChild = props.firstChild
	const lastChildOrNot = props.lastChild ? {} : style.containerBorder;
	const btnRef = useRef();

	useEffect(() => {
		btnRef?.current?.focus();
	}, []);

	return (
		<button className={"leo__button-sample"}
				{...(props.firstChild ? {ref: btnRef} : {})}
				style={[style.container, lastChildOrNot]}
				onClick={props.onClick}
				aria-label={!firstChild ?
					((!props.checked? "Zeige " : "Verstecke ") + "Kategorie: " + props.label + ", Preis: " + props.price) :
					props.label}
		>
			<div style={style.description} >
				<div style={style.categoryColor} />
				<div style={style.label} >
					{props.label}
				</div>
			</div>
			<div style={style.price} >
				<div style={style.label} >
					{props.price}
				</div>
			</div>
			{props.checked &&
				<FontAwesomeIcon
					style={style.checkIcon}
					icon="check"
				/>
			}
		</button>
	);
}

export default radium(CategoryListItem);
